import { ElementType, useState } from "react";
import { Button, Container, FormControl, FormGroup, FormLabel, FormText } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { useForm } from "../hooks/useForm";
import InputElement from "../models/common/InputElement";
import { useHistory } from "react-router-dom";


function Form(props) {


    let history = useHistory();
    // defining the initial state for the form
    const state = {
        form: props.form,
        resultForm: [...props.form.values()].flat(),
        action: props.action,
        clusterId: props.clusterId,
        formName: props.formName
    };

    const [formProps, setForm] = useState(props.form);

    const [apiResponse, setApiResponse] = useState(<span></span>);

    // getting the event handlers from our custom hook
    const { onChange, onChangeFile, onSubmit, values } = useForm(
        loginUserCallback,
        {} // not passing initialState values
    )

    function CreateMapForm() {
        let htmlList: JSX.Element[] = [];
        let indexFor = 0;
        for (let [key, value] of state.form) {
            CreateForm(value, <h3 key={key} className="mt-3 p-2 text-light bg-dark">{key}</h3>, htmlList, indexFor);
            indexFor += value.length + 1;
        }
        return htmlList;
    }

    function CreateForm(list: Array<InputElement>, htmlCode: JSX.Element, htmlList: JSX.Element[], indexFor: number): JSX.Element[] {
        htmlList[indexFor] = htmlCode;
        list.forEach(element => {
            indexFor += 1;
            if (element.type === "button") {
                // htmlList[indexFor] = <Button onClick={() => addTimeSlots(list)}>{element.name}</Button>;

            } else {
                const elementCapturedType = (element.as) ? element.as : "input";
                htmlList[indexFor] = createFormGroup(element, elementCapturedType, state.resultForm.filter(i => i.id === "Type"));
            }


        });
        return htmlList;
    }

    function createFormGroup(i: InputElement, elementCapturedType: ElementType<any>, lastValue: any) {
        const dropdown = i.options?.map((answer, index) => <option key={index} value={answer} >{answer}</option>) || null;
        var readOnly = i.isReadOnly;

        // if (i.name === "Description" && lastValue[0].value !== "WEBINAR") {
        //     readOnly = true;
            
        // }
        return <FormGroup key={"group-" + i.name} className="mt-3">
            <FormLabel className="font-weight-bold">{i.name.toUpperCase()}</FormLabel>
            <FormControl
                className={i.className}
                as={elementCapturedType}
                key={i.name}
                defaultValue={(i.type === 'file') ? undefined : i.value}
                name={i.name}
                id={i.name}
                type={i.type}
                placeholder={i.name}
                onChange={(i.type === 'file') ? onChangeFile : onChange}
                required={i.isRequired}
                readOnly={readOnly}
            >
                {dropdown}
            </FormControl>
            <FormText className="text-muted">
                {i.helpText}
            </FormText>
        </FormGroup>;
    }

    function SubmitButton() {
        addValuesToForm();

        const allFieldsFill = !state.resultForm.filter(i => i.isRequired === true).map(i => (i.value) ? true : false).includes(false);
        if (allFieldsFill) {
            return <Button className="mb-3" type='submit' >SUBMIT</Button>
        } else {
            return <Button className="mb-3" type='submit' disabled>SUBMIT</Button>
        };
    }

    return (

        <form onSubmit={onSubmit}>
            <Container>
                {CreateMapForm()}
                <SubmitButton />
                <Button className="mb-3 ml-3" onClick={cancelAction} >Cancel</Button>{apiResponse}
            </Container>
        </form>

    )

    function cancelAction() {
        history.push('/list-events');
    }

    // a submit function that will execute upon form submission
    async function loginUserCallback() {
        setApiResponse(<span className="ml-3 text-primary font-weight-bold">Submitting...</span>);
        state.action(state.resultForm, state.formName, state.clusterId).then(response => {
            // setApiResponse(<span className="ml-3 text-success font-weight-bold">Form submitted!</span>);
            alert("created/updated with sucess!");
            history.push('/list-events');
        }).catch(err => {
            const errorList = ["EVENT_NOT_UPDATED", "EVENT_NOT_EXIST"];
            const errorMessage = (errorList.find(e => e === err.response.data.errorCode)) ? err.response.data.errorDescription : "Error trying submitting the form, try again later!";
            setApiResponse(<span className="ml-3 text-danger font-weight-bold">{errorMessage}</span>);

        });

    }

    function addValuesToForm() {
        state
            .resultForm
            .map((i: InputElement) => changeValue(i));
    }

    function changeValue(form: InputElement): InputElement {
        if (values.hasOwnProperty(form.name)) {
            form.value = values[form.name];
        }
        return form;
    }

    // function addTimeSlots(list: Array<InputElement>) {
    //     const dateElement = new InputElement("Date", "date", true, false, "w-50", "e.g. date of the event");
    //     const timeElement = new InputElement("Time", "time", true, false, "w-50", "e.g. event time for the timezone choosen");
    //     let formChange = state.form;
    //     for (let [key, value] of formChange) {
    //         if (key === "Event Information") {
    //             const timeIndex = value.map(object => object.id).indexOf('Time');
    //             timeElement.name = timeElement.name + timeIndex;
    //             value.splice(timeIndex + 1, 0, dateElement);
    //             value.splice(timeIndex + 2, 0, timeElement);
    //             break;
    //         }
    //     }
    //     setForm(formChange);
    // }
}

export default withRouter(Form);



